


import UserAddForm from "../../components/Users/UserAddForm";



function UserAdd(){
   
    return (
        <UserAddForm />
        
    );
}
export default UserAdd;